import { Debit, EOB } from 'interfaces';
import { compareDateDesc } from 'utils/dateUtils';

export interface GroupedEOB extends EOB {
  tariffIDs: string[];
  tariffLabels: string[];
}

export const getDebitTariffLabel = (debit: Debit): string =>
  `${debit?.tariff?.prefix}${debit?.tariff?.code}`;

const sortDebitsByCreatedAtDesc = (a: Debit, b: Debit): number =>
  compareDateDesc(a.createdAt, b.createdAt);

export const groupDebitEOBs = (debits: Debit[] = []): GroupedEOB[] => {
  const latestTariffIDs = new Set<string>();
  const groupedEOBs = new Map<string, GroupedEOB>();

  [...debits].sort(sortDebitsByCreatedAtDesc).forEach((debit) => {
    if (latestTariffIDs.has(debit.tariffID)) {
      return;
    }

    latestTariffIDs.add(debit.tariffID);

    const tariffLabel = getDebitTariffLabel(debit);

    debit.eobs?.forEach((eob) => {
      const existingEOB = groupedEOBs.get(eob.code);

      if (!existingEOB) {
        groupedEOBs.set(eob.code, {
          ...eob,
          tariffIDs: [debit.tariffID],
          tariffLabels: [tariffLabel],
        });
        return;
      }

      if (!existingEOB.tariffIDs.includes(debit.tariffID)) {
        existingEOB.tariffIDs.push(debit.tariffID);
        existingEOB.tariffLabels.push(tariffLabel);
      }
    });
  });

  return Array.from(groupedEOBs.values());
};
